import { render, staticRenderFns } from "./regulatory.vue?vue&type=template&id=a5ccc3a4&"
import script from "./regulatory.vue?vue&type=script&lang=js&"
export * from "./regulatory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports